import { defineStore } from "pinia";
import { CategoryResult } from "~/composables";
import categoryListGql from "./graphql/categoryList.gql";
import categoryListByCategoryIdGql from "./graphql/categoryListByCategoryId.gql";
import categoryByCategoryIdGql from "./graphql/categoryByCategoryId.gql";

interface CategoryState {
  rawCategories: CategoryResult | null;
  categoryListById: CategoryResult | null;
  categoryById: CategoryResult | null;
}

export const useCategoryStore = defineStore("category", {
  state: (): CategoryState => ({
    rawCategories: null,
    categoryListById: null,
    categoryById: null,
  }),
  actions: {
    async load() {
      const { data }: { data: { categories?: CategoryResult } } = await this.$nuxt.app.$vsf.$magento.api.customQuery({ query: categoryListGql });
      this.rawCategories = data?.categories ?? null;
    },
    async loadById(id: string) {
      const { data }: { data: { categories?: CategoryResult } } = await this.$nuxt.app.$vsf.$magento.api.customQuery({
        query: categoryListByCategoryIdGql,
        queryVariables: { id: id },
      });
      this.categoryListById = data?.categories ?? null;
    },
    async loadCateById(id: string) {
      const { data }: { data: { categories?: CategoryResult } } = await this.$nuxt.app.$vsf.$magento.api.customQuery({
        query: categoryByCategoryIdGql,
        queryVariables: { id: id },
      });
      this.categoryById = data?.categories ?? null;
    },
  },
  getters: {
    categories(state) {
      if (state.rawCategories === null) {
        return null;
      }

      return state.rawCategories?.items[0];
    },
    getCategoryListById(state) {
      if (state.categoryListById === null) {
        return null;
      }

      return state.categoryListById?.items[0];
    },
    getCategoryById(state) {
      if (state.categoryById === null) {
        return null;
      }

      return state.categoryById?.items[0];
    },
  },
});
